import { isInBaiduApp } from "@/utils/env";
import { formatDateByDayJs } from "@/utils/formatDateByDayJs";

const formatDateHandler = (dateParam: number, format: any) => {
  // bug单见 https://jiandao-jira.djicorp.com/browse/PRCM-3101
  // 调整 next-intl 没有成功 通过特殊判断逻辑 在百度app中 使用dayjs策略 不在百度app 则保持原策略
  if (isInBaiduApp(navigator.userAgent)) {
    return formatDateByDayJs(dateParam);
  }

  const date = new Date(dateParam * 1000);
  const isCurrentYear = date.getFullYear() === new Date().getFullYear();
  const isCurrentMonth = date.getMonth() === new Date().getMonth();
  const isOverTwoDays = new Date().getDate() - date.getDate() >= 2;
  const isYesterday = new Date().getDate() - date.getDate() === 1;
  let formatDate = null;

  if (isCurrentYear) {
    if (isCurrentMonth) {
      if (isOverTwoDays) {
        formatDate = format.dateTime(date, {
          month: "numeric",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
        });
      } else if (isYesterday) {
        formatDate =
          format.relativeTime(date) +
          " " +
          format.dateTime(date, {
            hour: "numeric",
            minute: "numeric",
          });
      }
      formatDate = format.relativeTime(date);
    } else {
      formatDate = format.dateTime(date, {
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: false,
      });
    }
  } else {
    formatDate = format.dateTime(date, {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  }

  return (formatDate || "").replace(/\//g, "-");
};

export default formatDateHandler;
